import { render } from "./articleListe.vue?vue&type=template&id=e937b8a4&scoped=true"
import script from "./articleListe.vue?vue&type=script&lang=js"
export * from "./articleListe.vue?vue&type=script&lang=js"

import "./articleListe.vue?vue&type=style&index=0&id=e937b8a4&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e937b8a4"]])

export default __exports__